function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M51.0004 39.3L40.0004 20.3L28.9004 39.5C27.8004 41.7001 26.9004 43.9 26.9004 46.5C26.9004 53.8 32.8004 59.7001 40.0004 59.7001C47.3004 59.7001 53.2004 53.8 53.2004 46.5C53.2004 43.9 52.1004 41.4 51.0004 39.3Z",
  fill: "#BAA273"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40 3C60.4 3 77 19.6 77 40C77 60.4 60.4 77 40 77C19.6 77 3 60.4 3 40C3 19.6 19.6 3 40 3ZM40 0C17.9 0 0 17.9 0 40C0 62.1 17.9 80 40 80C62.1 80 80 62.1 80 40C80 17.9 62.1 0 40 0Z",
  fill: "#BAA273"
});

var SvgWaterFull = function SvgWaterFull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaterFull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/water-full.fa761819.svg";
export { ForwardRef as ReactComponent };